import { render, staticRenderFns } from "./NewsTrends.vue?vue&type=template&id=2c99b4bc&scoped=true&"
import script from "./NewsTrends.vue?vue&type=script&lang=js&"
export * from "./NewsTrends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c99b4bc",
  null
  
)

export default component.exports